import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { useCart } from "@/context/CartContext";
import { api, img, inr } from "@/lib/api";

export default function ProductDetail() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [missing, setMissing] = useState(false);
  const { add } = useCart();

  useEffect(() => {
    api.get(`/products/${id}`).then((r) => setP(r.data)).catch(() => setMissing(true));
  }, [id]);

  return (
    <div className="min-h-screen" data-testid="product-detail-page">
      <Header />
      <div className="mx-auto max-w-6xl px-6 pt-32">
        <Link to="/store" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#A89F91] hover:text-[#F3E5AB]" data-testid="back-to-store"><ArrowLeft className="h-4 w-4" /> Back to store</Link>
        {missing && <p className="font-serif-it text-2xl mt-10 text-[#A89F91]">This saree could not be found.</p>}
        {p && (
          <div className="grid md:grid-cols-2 gap-12 mt-10 fade-up">
            <div className="relative overflow-hidden rounded-sm">
              <img src={img(p.image_url)} alt={p.name} className={`w-full aspect-[4/5] object-cover ${p.in_stock ? "" : "grayscale"}`} />
              <div className="absolute inset-0 shadow-[inset_0_0_120px_40px_#0B0907]" />
            </div>
            <div className="md:pt-8">
              <p className="font-serif-it text-xl text-[#E06D3B]">{p.origin || "Heritage apparel"}</p>
              <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-2 leading-tight" data-testid="product-name">{p.name}</h1>
              <div className="flex items-baseline gap-4 mt-6">
                <span className="text-2xl text-[#F3E5AB]" data-testid="product-price">{inr(p.sale_price || p.price)}</span>
                {p.sale_price && <span className="text-[#6E6558] line-through">{inr(p.price)}</span>}
                {p.sale_price && <span className="text-[10px] uppercase tracking-[0.2em] bg-[#8B1E1E] px-2.5 py-1 rounded-full">Clearance</span>}
              </div>
              <div className="zari-divider my-8" />
              <p className="text-[#A89F91] leading-relaxed whitespace-pre-line" data-testid="product-description">{p.description}</p>
              {p.in_stock ? (
                <button onClick={() => add(p)} className="btn-glow mt-10 w-full sm:w-auto rounded-full bg-[#D4AF37] px-10 py-4 text-sm font-semibold uppercase tracking-[0.2em] text-[#0B0907] hover:bg-[#F3E5AB]" data-testid="add-to-cart-button">
                  Add to cart
                </button>
              ) : (
                <p className="mt-10 font-display tracking-[0.2em] text-[#6E6558]" data-testid="out-of-stock-label">OUT OF STOCK</p>
              )}
              <p className="mt-6 text-xs text-[#6E6558]">Handwoven - slight irregularities are the signature of the loom.</p>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
